import { useAppNotifications } from "@/hooks/useAppNotifications";
import { TOAST_AUTO_HIDE_DURATION } from "@/constants";
import { REQUEST_PRODUCT_PRICE_LIST } from "@/queries";
import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "@/utils/showErrorToast";

export function useRequestProductPriceList() {
  const { t } = useTranslation();
  const notifications = useAppNotifications();
  const [requestProductPriceList, { loading }] = useMutation(
    REQUEST_PRODUCT_PRICE_LIST
  );

  const notifySuccess = () => {
    notifications.show(t("product_pricelist.request_submitted_successfully"), {
      severity: "success",
      autoHideDuration: TOAST_AUTO_HIDE_DURATION,
    });
  };

  const notifyFailure = () => {
    notifications.show(t("product_pricelist.request_failed"), {
      severity: "error",
      autoHideDuration: TOAST_AUTO_HIDE_DURATION,
    });
  };

  const submitRequest = async (countryCode: string): Promise<boolean> => {
    try {
      const response = await requestProductPriceList({
        variables: {
          input: { countryCode },
        },
      });

      const succeeded = Boolean(response.data?.requestProductPriceList);
      if (succeeded) {
        notifySuccess();
        return true;
      }

      notifyFailure();
      return false;
    } catch (error) {
      showErrorToast(
        notifications,
        error,
        t("product_pricelist.request_failed")
      );
      return false;
    }
  };

  return {
    loading,
    submitRequest,
  };
}
